import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Button as BootstrapButton } from "react-bootstrap";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import axios from "axios";

import {
    SERVICE_LOCATION, GET_REJECTED_INVOICE_MEASURESCOUNT_BY_SITE, GET_REJECTED_INVOICING_MEASURES_FOR_SITE, RESEND_ACCOUNTS_FOR_REVIEW,
    UPLOAD_CUSTOMER_PAYMENT_FORM, DOWNLOAD_WORKCARD_DETAILS_BY_MEASUREIDs, GET_FITTERS_API, GET_SITE_CONTACTS_BY_SYSTEMID, UPDATE_SUBMISSION_STATUS
} from "../constants/endpoints";
import { COMPLETE_ALL_FIELDS, COMPLETE_ALL_MANDATORY_FIELDS } from "./../constants/errors";
import { TITLES } from "../constants/newBuildConstants";

import "./../assets/styles/table.css";
import "./../assets/styles/worksheets.css";
import "./../assets/styles/dialog.css";

const RejectedInvoices = (props) => {
    const toast = useRef(null);
    const fileInputRef = useRef(null)

    const { data } = props;
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";
    const userName = (data !== undefined && data !== null) ? data.data.userDetails.userName : "";

    const titles = TITLES;

    const [loading, setLoading] = useState(false);
    const [showPdfViewer, setShowPdfViewer] = useState(false);
    const [sitesData, setSitesData] = useState(null);
    const [selectedSite, setSelectedSite] = useState(null);
    const [selectedMeasure, setSelectedMeasure] = useState(null);
    const [disableResendToReviewButton, setDisableResendToReviewButton] = useState(true);
    const [showMeasures, setShowMeasures] = useState(false);
    const [measuresData, setMeasuresData] = useState(null);
    const [returnMeasures, setReturnMeasures] = useState(null);
    const [dialogHeader, setDialogHeader] = useState("");
    const [pdfUrl, setPdfUrl] = useState("");

    const [showSiteRevisitStatus, setShowSiteRevisitStatus] = useState(false);
    const [fitters, setFitters] = useState(null);
    const [assignedTo, setAssignedTo] = useState(0);
    const [rescheduledDate, setRescheduledDate] = useState(null);
    const [rescheduledComments, setRescheduledComments] = useState("");
    const [minDate, setMinDate] = useState(null);
    const [assignedToError, setAssignedToError] = useState(false);
    const [rescheduledCommentsError, setRescheduledCommentsError] = useState(false);

    const [showSiteAttentionStatusDialog, setShowSiteAttentionStatusDialog] = useState(false);
    const [emailTo, setEmailTo] = useState("");
    const [emailBody, setEmailBody] = useState("");
    const [emailSubject, setEmailSubject] = useState("");
    const [siteContactsList, setSiteContactsList] = useState(null);
    const [selectedSiteContacts, setSelectedSiteContacts] = useState(null);
    const [deleteSiteContactDialog, setDeleteSiteContactDialog] = useState(false);
    const [deleteSiteContact, setDeleteSiteContact] = useState(null);
    const [showAddSiteContactDialog, setShowAddSiteContactDialog] = useState(false);
    const [emailToError, setEmailToError] = useState("");
    const [emailBodyError, setEmailBodyError] = useState("");
    const [siteContactTitle, setSiteContactTitle] = useState("");
    const [siteContactFirstName, setSiteContactFirstName] = useState("");
    const [siteContactLastName, setSiteContactLastName] = useState("");
    const [siteContactPosition, setSiteContactPosition] = useState("");
    const [siteContactTelephone, setSiteContactTelephone] = useState("");
    const [siteContactMobile, setSiteContactMobile] = useState("");
    const [siteContactEmail, setSiteContactEmail] = useState("");
    const [siteContactComments, setSiteContactComments] = useState("");
    const [isPrimaryContact, setIsPrimaryContact] = useState(false);

    const [siteDataPage, setSiteDataPage] = useState(0);

    useEffect(() => {
        const currentDate = new Date();
        setRescheduledDate(currentDate);
        getSitesData();
        getFitters();
    }, [])

    const getSitesData = () => {
        setLoading(true);
        const endPoint = SERVICE_LOCATION + GET_REJECTED_INVOICE_MEASURESCOUNT_BY_SITE;
        axios.get(endPoint, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            if (response.data.isSuccess) {
                const res = response.data.data.measuresCountBySite;
                var filteredByDepot = userDepot === "NONE" ? res : res.filter((item) => item.depotName === userDepot);
                setSitesData(filteredByDepot);
                if (filteredByDepot.length === 0) {
                    setShowMeasures(false);
                }
            }
            else if (!response.data.isSuccess) {
                setSitesData(null);
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const getMeasuresData = (systemId, depot) => {
        setLoading(true);
        const endPoint = SERVICE_LOCATION + GET_REJECTED_INVOICING_MEASURES_FOR_SITE;
        const requestedData = {
            systemId: systemId,
            depot: depot
        }
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            if (response.data.isSuccess) {
                setDisableResendToReviewButton(true);
                setReturnMeasures(null);
                setMeasuresData(response.data.data.invoicingMeasures);
            }
            else if (!response.data.isSuccess) {
                setMeasuresData(null);
                setDisableResendToReviewButton(true);
                setReturnMeasures(null);
            }
            setShowMeasures(true);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const getSiteContacts = async () => {
        const systemId = selectedSite.systemId;
        const requestData = {
            systemId: systemId
        };
        const endPoint = SERVICE_LOCATION + GET_SITE_CONTACTS_BY_SYSTEMID;
        await axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    setSiteContactsList(response.data.data.siteContacts);
                }
                else if (!response.data.isSuccess) {
                    setSiteContactsList(null);
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                setSiteContactsList(null);
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const getFormattedDate = (dateToFormat) => {
        const year = dateToFormat.getFullYear();
        const month = String(dateToFormat.getMonth() + 1).padStart(2, "0");
        const day = String(dateToFormat.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;
        return formatedDate;
    }

    // Site search functionality
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    const clearFilter = () => {
        setFilters({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
        setGlobalFilterValue("");
    };

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="flex justify-content-end txt-right">
                        <Button className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = renderHeader();
    // Search site functionality Ends here

    const onRowSelect = (e) => {
        setSelectedSite(e.data);
        getMeasuresData(e.data.systemId, e.data.depot);
    }

    const handleReturnMeasureSelection = (e) => {
        setReturnMeasures(e.value);
        setDisableResendToReviewButton(false);
    }

    const handleBackToAccounts = () => {
        setReturnMeasures(null);
        setMeasuresData(null);
        setShowMeasures(false);
    }

    const getFitters = async () => {
        const requestData = {
            depot: userDepot
        }
        const endPoint = SERVICE_LOCATION + GET_FITTERS_API;
        await axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    setFitters(response.data.data.fitterDetails);
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const handleResendForReview = () => {
        setLoading(true);
        var selectedReturnMeasureIds = [];
        returnMeasures.forEach(acc => {
            const measureIds = {
                measureId: acc.measureId
            }
            selectedReturnMeasureIds.push(measureIds);
        })
        const endPoint = SERVICE_LOCATION + RESEND_ACCOUNTS_FOR_REVIEW;
        axios.post(endPoint, selectedReturnMeasureIds, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                getMeasuresData(selectedSite.systemId, selectedSite.depot);
                getSitesData();
                setDisableResendToReviewButton(true);
                toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 5000 });
            }
            else if (!response.data.isSuccess) {
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const handleShowWorkCard = (job) => {
        return <BootstrapButton id="view" onClick={() => viewWorkCard(job)}>View</BootstrapButton>
    }

    const viewWorkCard = (job) => {
        setLoading(true);
        setSelectedMeasure(job);
        var selectedMeasureIds = [];
        const measureIds = {
            measureId: job.measureId
        }
        selectedMeasureIds.push(measureIds);
        const endPoint = SERVICE_LOCATION + DOWNLOAD_WORKCARD_DETAILS_BY_MEASUREIDs;
        axios.post(endPoint, selectedMeasureIds, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                if (response.data.data.downloadedWorkCards.length > 0) {
                    (response.data.data.downloadedWorkCards).forEach(workcard => {
                        const base64 = workcard.chunks.join("");
                        if (base64 !== null && base64 !== undefined && base64 !== "") {
                            const byteCharacters = atob(base64);
                            const byteNumbers = new Array(byteCharacters.length);
                            for (let i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            const byteArray = new Uint8Array(byteNumbers);
                            const blob = new Blob([byteArray], { type: "application/pdf" });
                            const url = URL.createObjectURL(blob);
                            setPdfUrl(url);
                            setDialogHeader(`${job.plotNo} - ${job.plotDescription}`);
                            setShowPdfViewer(true);
                        }
                        else {
                            toast.current.show({ severity: "error", summary: "Error", detail: "Error retrieving pdf data", life: 5000 });
                        }
                    });
                }
            }
            else if (!response.data.isSuccess) {
                setPdfUrl("");
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
        })
    }

    const handleHidePDFViewer = () => {
        setShowPdfViewer(false);
    }

    // Measure search functionality
    const [measureFilters, setMeasureFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [globalMeasureFilterValue, setGlobalMeasureFilterValue] = useState("");

    const onGlobalMeasureFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...measureFilters };

        _filters["global"].value = value;

        setMeasureFilters(_filters);
        setGlobalMeasureFilterValue(value);
    };

    const clearMeasureFilter = () => {
        setMeasureFilters({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
        setGlobalMeasureFilterValue("");
    };

    const renderMeasuresHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 padr-20">
                    <Button className="btn-secondary" onClick={handleResendForReview} disabled={disableResendToReviewButton}>Resend For Review</Button>
                </div>
                <div className="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
                    <div className="flex justify-content-end txt-right">
                        <Button className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearMeasureFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalMeasureFilterValue} onChange={onGlobalMeasureFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };
    // Measure search functionality ends here

    //File upload
    const handleFileUpload = () => {
        fileInputRef.current.click();
    }

    const handleFileChange = (event) => {
        setShowPdfViewer(false);
        setLoading(true);
        const selectedFile = event.target.files[0];
        if (selectedFile.type.startsWith("application/pdf") || selectedFile.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onloadend = () => {
                const base64String = reader.result;
                if (base64String !== "") {
                    const jobData = [{
                        submissionId: selectedMeasure.submissionId,
                        measureId: selectedMeasure.measureId
                    }];
                    const requestedData = {
                        submissionMeasureIdsList: jobData,
                        base64String: base64String,
                        fileType: selectedFile.type.startsWith("image/") ? "image" : "pdf"
                    };
                    const endPoint = SERVICE_LOCATION + UPLOAD_CUSTOMER_PAYMENT_FORM;
                    axios.post(endPoint, requestedData, {
                        headers: {
                            Authorization: `Bearer ${data.data.token}`,
                        },
                    }).then((response) => {
                        setLoading(false);
                        if (response.data.isSuccess) {
                            viewWorkCard(selectedMeasure);
                            toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 3000 });
                        }
                        else if (!response.data.isSuccess) {
                            toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                        }
                    }).catch((error) => {
                        setLoading(false);
                        toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
                    })
                }
            };
        }
        else {
            toast.current.show({ severity: "error", summary: "Error", detail: "Only PDF and Image Files are allowed", life: 5000 });
        }
    };
    //End File upload

    const handleHideStatusDialogVisibility = () => {
        setAssignedTo(0);
        setAssignedToError(false);
        setRescheduledComments("");
        setRescheduledCommentsError(false);
        setRescheduledDate(null);
        setShowSiteRevisitStatus(false);

        setEmailBody("");
        setEmailTo("");
        setEmailSubject("");
        setSiteContactsList(null);
        setSelectedSiteContacts(null);
        setEmailBodyError(false);
        setEmailToError(false);
        setShowSiteAttentionStatusDialog(false);
    }

    const handleChangeRevisitStatus = () => {
        assignedTo === 0 ? setAssignedToError(true) : setAssignedToError(false);
        rescheduledComments.trim() === "" ? setRescheduledCommentsError(true) : setRescheduledCommentsError(false);

        if (assignedTo === 0 || rescheduledComments.trim() === "") {
            toast.current.show({ severity: "error", summary: "Error", detail: COMPLETE_ALL_FIELDS, life: 5000 });
        }
        else {
            updateChangedStatus(3);
        }
    }

    const handleSiteRevisit = () => {
        const today = new Date();
        setMinDate(today);
        setRescheduledDate(today);
        setShowSiteRevisitStatus(true);
    }

    const handleRescheduledDateChange = (e) => {
        const dateSelected = e.value;
        setRescheduledDate(dateSelected);
    }

    const siteRevisitStatusfooterContent = (
        <div>
            <Button label="Exit" size="small" onClick={handleHideStatusDialogVisibility} severity="secondary" outlined />
            <Button label="Submit" size="small" onClick={handleChangeRevisitStatus} outlined />
        </div>
    );

    const handleSiteAttention = () => {
        getSiteContacts();
        var strEmailBody = `<p>Greetings,</p><p><br></p><p>Our records show we have worksheets requiring your sign off on site <strong>${selectedSite.siteName}.</strong></p><p><br></p><p>Please follow the provided link and sign off the work to allow us to send you a copy of the completed worksheet in due course.</p><p><a style="cursor: pointer" href="https://eeg-clientportal.azurewebsites.net/" target="#">Client Portal</a></p><p><br></p><p>Kindest Regards,</p><p>Max Energy</p>`;
        setEmailBody(strEmailBody);

        var strEmailSubject = `Site Attention Required: ${selectedSite.siteName} Plot-${selectedSite.plotNumber}`;
        setEmailSubject(strEmailSubject);
        setShowSiteAttentionStatusDialog(true);
    }

    const handleShowAddSiteContact = () => {
        setShowAddSiteContactDialog(true);
    }

    const handleSiteContactSelection = (e) => {
        setSelectedSiteContacts(e.value);
        var strEmailTo = "";
        (e.value).forEach(sc => {
            if (sc.email !== "") {
                strEmailTo = strEmailTo + sc.email + ";\n";
            }
        });
        setEmailTo(strEmailTo);
    }

    const siteContactsHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <Button id="add-site-contact" onClick={handleShowAddSiteContact}>Add Site Contact</Button>
                </div>
            </div>
        )
    }

    const confirmDeleteContact = (rowData) => {
        setDeleteSiteContactDialog(true);
        setDeleteSiteContact(rowData);
    }

    const handleDeleteSiteContact = () => {
        let allContacts = siteContactsList.filter((val) => val.id !== deleteSiteContact.id);
        setSiteContactsList(allContacts);
        toast.current.show({ severity: "success", summary: "Success", detail: "succesfully deleted the newly created site contact", life: 3000 });
        setDeleteSiteContactDialog(false);
    }

    const deleteProductDialogFooter = (
        <div>
            <Button label="No" size="small" onClick={() => setDeleteSiteContactDialog(false)} severity="secondary" outlined />
            <Button label="Yes" size="small" onClick={handleDeleteSiteContact} severity="danger" outlined />
        </div>
    );

    const deleteBodyTemplate = (rowData) => {
        if (rowData.isAddSiteContact) {
            return (
                <div>
                    <Button icon="pi pi-trash" rounded outlined severity="danger" onClick={() => confirmDeleteContact(rowData)} />
                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    };

    const handleSiteAttentionStatus = () => {
        updateChangedStatus(4);
    }

    const onHideAddSiteContactsDialog = () => {
        setSiteContactTitle("");
        setSiteContactFirstName("");
        setSiteContactLastName("");
        setSiteContactTelephone("");
        setSiteContactMobile("");
        setSiteContactEmail("");
        setSiteContactComments("");
        setSiteContactPosition("");
        setIsPrimaryContact(false);
        setShowAddSiteContactDialog(false);
    }

    const handleOnAddSiteContact = () => {
        if (!siteContactTitle || !siteContactFirstName || !siteContactLastName || !siteContactEmail) {
            toast.current.show({ severity: "error", summary: "Error", detail: COMPLETE_ALL_MANDATORY_FIELDS, life: 5000 });
        }
        else {
            var allSiteContacts = siteContactsList ?? [];
            const maxId = allSiteContacts.reduce((max, obj) => (obj.id > max ? obj.id : max), 0)
            const siteContact = {
                id: maxId + 1,
                systemId: selectedSite.systemId,
                title: siteContactTitle.title,
                firstName: siteContactFirstName,
                lastName: siteContactLastName,
                position: siteContactPosition,
                telephone: siteContactTelephone,
                mobile: siteContactMobile,
                email: siteContactEmail,
                comments: siteContactComments,
                isPrimaryContact: isPrimaryContact ? "Y" : "N",
                isAddSiteContact: true
            }
            allSiteContacts.push(siteContact);
            setSiteContactsList(allSiteContacts);
            onHideAddSiteContactsDialog();
        }
    }

    const addSiteContactfooterContent = (
        <div>
            <Button label="Exit" size="small" onClick={onHideAddSiteContactsDialog} severity="secondary" outlined />
            <Button label="Submit" size="small" onClick={handleOnAddSiteContact} severity="secondary" outlined />
        </div>
    );

    const siteAttentionStatusfooterContent = (
        <div>
            <Button label="Exit" size="small" onClick={handleHideStatusDialogVisibility} severity="secondary" outlined />
            <Button label="Submit" size="small" onClick={() => handleSiteAttentionStatus(true)} severity="secondary" outlined />
        </div>
    );

    const updateChangedStatus = (statusId) => {
        const formatedRescheduledDate = getFormattedDate(rescheduledDate);
        var selectedSubmissions = [];
        let emailList = emailTo.split(";\n");
        let finalEmailList = emailList.slice(0, -1);
        const submission = {
            submissionId: selectedMeasure.submissionId,
            measureId: selectedMeasure.measureId,
            submissionStatus: statusId,
            submittedBy: userName,
            rescheduledDate: formatedRescheduledDate,
            assignedTo: assignedTo.fitterId,
            rescheduledComments: rescheduledComments,
            emailTo: finalEmailList,
            emailBody: emailBody,
            emailSubject: emailSubject
        }
        selectedSubmissions.push(submission);

        const endPoint = SERVICE_LOCATION + UPDATE_SUBMISSION_STATUS;
        axios.post(endPoint, selectedSubmissions, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 5000 });
                    setShowPdfViewer(false);
                    setShowSiteRevisitStatus(false);
                    setShowSiteAttentionStatusDialog(false);
                    getMeasuresData(selectedSite.systemId, selectedSite.depot);
                    getSitesData();
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
            })
    }

    const sitesTablePageChange = (event) => {
        setSiteDataPage(event.first / event.rows);
    };

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }
            <Toast ref={toast} />

            {!showMeasures &&
                <div className="worksheets-section">
                    <h4>Rejected Accounts Review</h4>
                    <DataTable className="font-12" value={sitesData} datakey="systemId" paginator rows={10} first={siteDataPage * 10}
                        onPage={sitesTablePageChange} selectionMode="single" selection={selectedSite} onSelectionChange={(e) => setSelectedSite(e.value)}
                        onRowSelect={onRowSelect} metaKeySelection={false} filters={filters} header={header}
                        globalFilterFields={["clientAccount", "clientName", "site", "contractType", "systemId", "siteRefNo", "depot", "depotName", "totalRevenue", "measuresCount"]}
                        scrollable tableStyle={{ minWidth: "50rem" }} emptyMessage="No rejected accounts available to review.">
                        <Column field="clientAccount" header="Client Account"></Column>
                        <Column field="clientName" header="Client Name"></Column>
                        <Column field="site" header="Site"></Column>
                        <Column field="contractType" header="ContractType"></Column>
                        <Column field="systemId" header="SystemId" hidden></Column>
                        <Column field="siteRefNo" header="Site RefNo"></Column>
                        <Column field="depot" header="DepotCode" hidden></Column>
                        <Column field="depotName" header="Depot"></Column>
                        <Column field="totalRevenue" header="Total Revenue(£)"></Column>
                        <Column field="measuresCount" header="Measures"></Column>
                    </DataTable>
                </div>
            }

            {showMeasures &&
                <div className="worksheets-section">
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padt-10 txt-bold">
                            {selectedSite.clientAccount} - {selectedSite.site}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div className="flex justify-content-end txt-right" onClick={handleBackToAccounts}>
                                <Button id="back" label="Back to Accounts" link onClick={handleBackToAccounts} />
                            </div>
                        </div>
                    </div>
                    <DataTable className="font-12" value={measuresData} selection={returnMeasures} selectionMode="checkbox"
                        onSelectionChange={handleReturnMeasureSelection} dataKey="measureId" paginator rows={10} rowsPerPageOptions={[10, 20, 50]} filters={measureFilters}
                        scrollable header={renderMeasuresHeader} globalFilterFields={["site", "measureId", "worksheetNo", "plotId", "plotNo", "plotDescription",
                            "product", "quantity", "revenue", "paymentCardRequired", "paymentCardIncluded", "comments", "invoiceStatusUpdatedBy"]} tableStyle={{ minWidth: "50rem" }} emptyMessage="No rejected accounts available to review.">
                        <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                        <Column field="site" header="Site" hidden></Column>
                        <Column field="worksheetNo" header="WorksheetNo" hidden></Column>
                        <Column field="plotId" header="SystemId" hidden></Column>
                        <Column field="plotNo" header="Plot"></Column>
                        <Column field="plotDescription" header="Description" hidden></Column>
                        <Column field="product" header="Measure"></Column>
                        <Column field="measureId" header="MeasureId"></Column>
                        <Column field="quantity" header="Quantity"></Column>
                        <Column field="revenue" header="Revenue(£)"></Column>
                        <Column field="paymentCardRequired" header="PaymentCardRequired"></Column>
                        <Column field="paymentCardIncluded" header="PaymentCardIncluded" sortable></Column>
                        <Column field="invoiceStatusUpdatedBy" header="Rejected By"></Column>
                        <Column field="comments" header="Reason For Rejection"></Column>
                        <Column header="Workcard" body={handleShowWorkCard}></Column>
                    </DataTable>
                </div>
            }

            <Dialog header={dialogHeader} style={{ width: "310vw" }} visible={showPdfViewer} onHide={handleHidePDFViewer}>
                <div>
                    <div className="row">
                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                            <Button id="show-siteattention-measures" label="Back to Accounts" link style={{ fontSize: "12px", paddingLeft: "0px" }} onClick={handleHidePDFViewer} />
                        </div>
                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 txt-right padb-10">
                            <Button id="siteRevisit" className="btn-secondary marr-10" onClick={handleSiteRevisit}>Site Revisit</Button>
                            <Button id="siteAttention" className="btn-secondary marr-10" onClick={handleSiteAttention}>Site Attention</Button>

                            <Button className="btn-secondary" onClick={handleFileUpload}>Upload Customer Payment Card</Button>
                            <input ref={fileInputRef} type="file" accept=".pdf, image/*" style={{ display: "none", width: "1024px", height: "768px" }} onChange={handleFileChange} />
                        </div>
                    </div>

                    <div>
                        <iframe title="PDF Viewer" width="100%" height="500px" src={pdfUrl || ""} />
                    </div>
                </div>
            </Dialog>

            <Dialog header="Revisit Details" style={{ width: "50vw" }} visible={showSiteRevisitStatus} onHide={handleHideStatusDialogVisibility} footer={siteRevisitStatusfooterContent}>
                <div>
                    <div className="col-12 padr-20">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 cancel-feild">
                                <label htmlFor="assignedTo">Assigned To</label>
                                <Dropdown value={assignedTo} onChange={(e) => setAssignedTo(e.value)} options={fitters} optionLabel="fullName"
                                    placeholder="Select Fitter" className="w-full md:w-14rem" />
                                {assignedToError && <small className="p-error">This field is required</small>}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 padr-20">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 cancel-feild">
                                <label htmlFor="rescheduledDate">Revisit Date</label>
                                <Calendar value={rescheduledDate} onChange={handleRescheduledDateChange} minDate={minDate} showIcon dateFormat="dd/mm/yy" />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 padr-20">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 cancel-feild">
                                <label htmlFor="rescheduledComments">Reason For Revisit</label>
                                <InputText value={rescheduledComments} id="rescheduledComments" onChange={(e) => setRescheduledComments(e.target.value)} className="p-inputtext-sm" />
                                {rescheduledCommentsError && <small className="p-error">This field is required</small>}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog header="Site Attention" style={{ width: "50vw" }} visible={showSiteAttentionStatusDialog} onHide={handleHideStatusDialogVisibility} footer={siteAttentionStatusfooterContent}>
                <div>
                    <div className="row" disabled>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 cancel-feild">
                                <label htmlFor="emailTo">Email To</label>
                                <InputTextarea disabled rows={4} cols={30} value={emailTo} onChange={(e) => setEmailTo(e.value)} autoResize tooltip="Select recipients from below site contacts table" tooltipOptions={{ position: "top" }} />
                                {emailToError && <small className="p-error">This field is required</small>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <DataTable className="font-12" value={siteContactsList} selectionMode="checkbox" selection={selectedSiteContacts}
                                onSelectionChange={handleSiteContactSelection} header={siteContactsHeader} scrollable dataKey="id"
                                tableStyle={{ minWidth: "40rem" }} emptyMessage="No site contacts availabe for the selected worksheet.">
                                <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                                <Column field="id" header="Id" className="table-header" hidden></Column>
                                <Column field="systemId" header="SystemId" className="table-header" hidden></Column>
                                <Column field="title" header="Title" className="table-header" hidden></Column>
                                <Column field="firstName" header="FirstName" className="table-header"></Column>
                                <Column field="lastName" header="LastName" className="table-header"></Column>
                                <Column field="email" header="Email" className="table-header"></Column>
                                <Column field="position" header="Position" className="table-header"></Column>
                                <Column field="telephone" header="Telephone" className="table-header" hidden></Column>
                                <Column field="mobile" header="Mobile" className="table-header" hidden></Column>
                                <Column field="comments" header="Comments" className="table-header" hidden></Column>
                                <Column field="isPrimaryContact" header="IsPrimaryContact" className="table-header" hidden></Column>
                                <Column body={deleteBodyTemplate} header="Delete" headerStyle={{ width: "3rem" }} exportable={false}></Column>
                            </DataTable>
                        </div>
                    </div>
                    <div className="col-12 padr-20">
                        <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 padr-20 padt-23">
                            <div className="flex flex-column gap-2 cancel-feild">
                                <label htmlFor="emailBody">Email</label>
                                <Editor value={emailBody} onTextChange={(e) => setEmailBody(e.htmlValue)} style={{ height: "200px" }} />
                                {emailBodyError && <small className="p-error">This field is required</small>}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={deleteSiteContactDialog} style={{ width: "20vw" }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={() => setDeleteSiteContactDialog(false)}>
                <div className="confirmation-content">
                    {deleteSiteContact && (
                        <span>
                            Are you sure you want to delete the contact for <b>{deleteSiteContact.firstName} {deleteSiteContact.lastName}</b>?
                        </span>
                    )}
                </div>
            </Dialog>

            <Dialog header="Add Site Contact" style={{ width: "30vw" }} visible={showAddSiteContactDialog} onHide={onHideAddSiteContactsDialog} footer={addSiteContactfooterContent}>
                <div className="row">
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 input-feild">
                            <label htmlFor="depot">Title<span style={{ color: 'red' }}>*</span></label>
                            <Dropdown value={siteContactTitle} onChange={(e) => setSiteContactTitle(e.value)} options={titles} optionLabel="title"
                                placeholder="Select Title" className="w-full md:w-14rem" />
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 input-feild">
                            <label htmlFor="siteContactFirstName">First Name<span style={{ color: 'red' }}>*</span></label>
                            <InputText value={siteContactFirstName} id="siteContactFirstName" onChange={(e) => setSiteContactFirstName(e.target.value)} className="p-inputtext-sm" />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 input-feild">
                            <label htmlFor="siteContactLastName">Last Name<span style={{ color: 'red' }}>*</span></label>
                            <InputText value={siteContactLastName} id="siteContactLastName" onChange={(e) => setSiteContactLastName(e.target.value)} className="p-inputtext-sm" />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 input-feild">
                            <label htmlFor="siteContactPosition">Position</label>
                            <InputText value={siteContactPosition} id="siteContactPosition" onChange={(e) => setSiteContactPosition(e.target.value)} className="p-inputtext-sm" />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 input-feild">
                            <label htmlFor="siteContactTelephone">Phone</label>
                            <InputText value={siteContactTelephone} id="siteContactTelephone" onChange={(e) => setSiteContactTelephone(e.target.value)} className="p-inputtext-sm" />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 input-feild">
                            <label htmlFor="siteContactMobile">Mobile</label>
                            <InputText value={siteContactMobile} id="siteContactMobile" onChange={(e) => setSiteContactMobile(e.target.value)} className="p-inputtext-sm" />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 input-feild">
                            <label htmlFor="siteContactEmail">Email<span style={{ color: 'red' }}>*</span></label>
                            <InputText value={siteContactEmail} id="siteContactEmail" onChange={(e) => setSiteContactEmail(e.target.value)} className="p-inputtext-sm" />
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                        <div className="flex flex-column gap-2 input-feild">
                            <label htmlFor="siteContactComments">Comments</label>
                            <InputText value={siteContactComments} id="siteContactComments" onChange={(e) => setSiteContactComments(e.target.value)} className="p-inputtext-sm" />
                        </div>
                    </div>

                    <div className="col-12 padr-20 padb-20">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            <div className="flex flex-column gap-2">
                                <label htmlFor="isPrimaryContact" className="padr-5">IsPrimaryContact</label>
                                <Checkbox value={isPrimaryContact} id="isPrimaryContact" onChange={e => setIsPrimaryContact(e.checked)} checked={isPrimaryContact}></Checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default RejectedInvoices;